export const imageMaxSize = 2;

export const notesMaxSize = 10;

export const audioMaxSize = 15;

export const pdfMaxSize = 15;

export const videoMaxSize = 50;
